import React from 'react'

// GraphQL
import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'
import { findRedeemablePass } from 'lib/cart/decorators/cartForm'

const withMutation = WrappedComponent => {
  return props => {
    const {
      camper, // via query
      cartForm, // via Redux state
      onMutationCompleted, // via withFormResults
      onMutationError, // via withFormResults
      setFormErrors, // via withFormResults
      addGuestPass, // via Redux actions
      notify, // via Redux actions
      setForm, // via withState
      setFormOpen // via withState
    } = props

    /**
    @private
    Adds additional handling to the standard `onMutationCompleted` provided by
    `withFormResults`:
    * Adds an error if valid redeemable pass is already in client-side cartForm
    * Adds guest pass to cart and clears form if successful validation
    **/
    const handleMutationCompleted = data => {
      const {
        inputErrors,
        formErrors,
        fieldResult: redeemablePass
      } = onMutationCompleted(data)

      if (!inputErrors.length) {
        if (findRedeemablePass({ redeemablePass, cartForm })) {
          setFormErrors(
            Object.assign(
              { code: 'That code is already in your cart.' },
              formErrors
            )
          )
        } else {
          // add valid pass to redux
          addGuestPass({ camper, redeemablePass })

          // show success notification
          const message = `${redeemablePass.days} ${redeemablePass.product.description} added to cart for ${camper.firstName}`
          notify({ message })

          // clear and close the form
          setForm({ code: '' })
          setFormOpen(false)
        }
      }
    }

    // setup GraphQL mutation
    const [validateRedeemablePass, { loading }] = useMutation(mutation, {
      onCompleted: handleMutationCompleted,
      onError: onMutationError
    })

    return (
      <WrappedComponent
        mutationLoading={loading}
        validateRedeemablePass={validateRedeemablePass}
        {...props}
      />
    )
  }
}

export default withMutation
